<template>
  <div>
    <common-dialog
      ref="dialog"
      width="990px"
      show-save-button
      unit="商品信息"
      edit-title
      id-key="RecordId"
      :data="data"
      form-label-width="100px"
      :form-rules="rules"
      :get-data-func="api.info"
      :save-func="() => {}"
      @create-opened="onCreateOpened"
      @edit-opened="onEditOpened"
      close-on-saved
      :before-save="onBeforeSave"
      @closed="onClosed"
    >
      <template slot="form">
        <div class="box-header">基础信息</div>
        <div class="box">
          <el-row>
            <el-col :span="isMB ? 24 : 12">
              <el-form-item label="商品名称" prop="title">
                <el-input
                  v-model="data.title"
                  placeholder="请输入商品名称"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="isMB ? 24 : 12">
              <el-form-item label="商品类别">
                <tree-select
                  ref="treeSelect"
                  :props="props"
                  :options="categorys"
                  accordion
                  filterable
                  parentSelect
                  placeholder="请选择分类"
                  @node-select="onTreeSelect($event)"
                />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="isMB ? 24 : 12">
              <el-form-item label="商品编码" prop="GoodsCode">
                <el-input
                  v-model="data.GoodsCode"
                  placeholder="请输入商品编码"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="isMB ? 24 : 12">
              <el-form-item label="商品单位" prop="MainUnitid">
                <el-select
                  v-model="data.MainUnitid"
                  placeholder="请选择商品单位"
                  clearable
                >
                  <el-option
                    v-for="(i, k) in Units"
                    :key="k"
                    :label="i.UnitName"
                    :value="i.RecordId"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="isMB ? 24 : 12">
              <el-form-item label="商品品牌" prop="BrandId">
                <el-select
                  v-model="data.BrandId"
                  placeholder="请选择商品品牌"
                  clearable
                  filterable
                >
                  <el-option
                    v-for="(i, k) in Brands"
                    :key="k"
                    :label="i.BrandName"
                    :value="i.RecordId"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="isMB ? 24 : 12">
              <el-form-item label="贸易模式" prop="TradeMode">
                <el-select
                  v-model="data.IfImport"
                  placeholder="请选择贸易模式"
                  clearable
                >
                  <el-option label="跨境进口" :value="0"></el-option>
                  <el-option label="一般贸易" :value="1"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="isMB ? 24 : 12">
              <el-form-item label="序号" prop="OrderId">
                <el-input-number v-model="data.OrderId" :min="0" />
              </el-form-item>
            </el-col>

            <el-col :span="isMB ? 24 : 12">
              <el-form-item label="状态" prop="State">
                <el-radio-group v-model="data.State">
                  <el-radio :label="1">正常</el-radio>
                  <el-radio :label="0">停用</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
          </el-row>
        </div>
        <div class="box-header">
          <span>商品属性</span>
          <!-- <div>
            <el-button type="primary" @click="addAttribute">添加</el-button>
            <el-button type="danger" @click="delAttribute">删除</el-button>
          </div> -->
        </div>
        <div class="box">
          <el-row v-for="(i, k) in pAttr" :key="k">
            <el-col>
              <el-form-item :label="i.name" prop="name" label-width="130px">
                <el-radio-group v-model="i.sval" v-if="i.sValue">
                  <el-radio v-for="(g, f) in i.sValue" :key="f" :label="g">{{
                    g
                  }}</el-radio>
                </el-radio-group>
                <el-input
                  v-model="i.sval"
                  :placeholder="i.name"
                  v-else
                ></el-input> </el-form-item
            ></el-col>
          </el-row>
        <div v-if="pAttr.length==0" class="el-table__empty-block" style="height: 100%; width: 929px;"><span class="el-table__empty-text">暂无数据</span></div>
        </div>
        <div class="box-header">
          <span>规格型号</span>
          <div>
            <el-button type="primary" @click="addAttribute">添加</el-button>
            <el-button type="danger" @click="delAttribute">删除</el-button>
          </div>
        </div>
        <el-table
          ref="attributes"
          :data="data.Attributes"
          border
          style="width: 100%"
          @selection-change="selectAttribute"
        >
          <el-table-column type="selection" width="35" />
          <!-- 属性明细 -->

          <el-table-column prop="AttributeName" label="规格名称" width="370">
            <template slot-scope="{ row }">
              <el-input
                v-model="row.AttributeName"
                placeholder="请输入规格名称"
                @input="setEdit(row)"
              ></el-input>
            </template>
          </el-table-column>
          <el-table-column prop="AttributeCode" label="规格编码" width="370">
            <template slot-scope="{ row }">
              <el-input
                v-model="row.AttributeCode"
                placeholder="请输入规格编码"
                @input="setEdit(row)"
              ></el-input>
            </template>
          </el-table-column>

          <el-table-column prop="OrderId" label="序号">
            <template slot-scope="{ row }">
              <el-input-number
                v-model="row.OrderId"
                :min="0"
                @change="setEdit(row)"
              />
            </template>
          </el-table-column>
        </el-table>
      </template>
    </common-dialog>
  </div>
</template>
<script>
import editDialogMixin from "@/mixins/editDialog";
import commonDialog from "@/components/common/dialog";

export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog,
  },
  data() {
    return {
      data: {
        RecordId: 0,
        OrderId: null, //序号
        BarCode: "", //条码
        QrCode: "", //二维码
        GoodsCode: "", //编码
        GoodsName: "", //名称
        TypeId: null, //分类
        TypeName: "",
        TypeNameChain: "", //分类名称链
        LabelId: null, //标签
        BrandId: null, //品牌
        TradeMode: null, //贸易模式 0跨境进口，1一般贸易
        GoodsModel: "", //规格型号
        MainUnitid: null, //主单位
        AuxiliaryUnitid: null, //辅单位
        DistributionPrice: null,
        OriginalPrice: null,
        PlatformPrice: null,
        GoodsRemark: "", //备注
        sale_range: "",
        return_illustrate: "",
        State: 1, //状态 - 0：停用，1：正常
        Attributes: [], //属性
        Labeldetails: [], //标签,必须与后端得映射的名称定义相同
      },
      DelAttributes: [], //将要删除的属性
      SelectAttributes: [], //选中的属性
      labelList: [],
      place: [],
      arr2: [],
      api: require("@/api/goods/info").default,
      brand_api: require("@/api/goods/brand").default,
      unit_api: require("@/api/goods/unit").default,
      lable_api: require("@/api/goods/label").default,
      mall_api: require("@/api/goods/mall").default,
      isMB: this.$store.state.isMB,
      rules: {
        GoodsCode: [{ required: true, message: "商品编码不能为空" }],
        GoodsName: [{ required: true, message: "商品名称不能为空" }],
        // DistributionPrice: [{ required: true, message: "分销价不能为空" }],
        // OriginalPrice: [{ required: true, message: "销售指导价不能为空" }],
        // PlatformPrice: [{ required: true, message: "市场价不能为空" }],
        BrandId: [{ required: true, message: "请选择品牌" }],
        MainUnitid: [{ required: true, message: "请选择商品单位" }],
        TradeMode: [{ required: true, message: "请选择贸易模式" }],
        OrderId: [{ required: true, message: "序号不能为空" }],
      },
      Brands: [],
      Units: [],
      categorys: [],
      props: {
        // 配置项（必选）
        value: "cat_id",
        label: "name",
        children: "children",
      },
      categorysAll: [],
      cats: [],
      product_attr_list: [],//商品属性
      product_qua_list: [],//商品资质
      pAttr: [],
    };
  },
  mounted() {
    this.unit_api.list({ State: 1 }).then((res) => {
      if (res.Code == 0) {
        this.Units = res.Data;
      }
    });
    this.mall_api.categoryTree().then((res) => {
      if (res.Code == 0) {
        this.categorysAll = res.Data;
        this.categorys = this.$commonJs.toTreeData(
          res.Data,
          "cat_id",
          "f_cat_id",
          "children",
          null
        );
        console.log(this.categorys, "this.categorys");
      }
    });
  },
  methods: {
    onTreeSelect(data) {
      console.log("data", data);
      if (data) {
        if (data.level == 1) {
        } else if (data.level == 2) {
        } else if (data.level == 3) {
          var fcats = this.categorysAll.filter(
            (x) => x.cat_id == data.f_cat_id
          )[0];
          console.log(fcats, "fcats");
          this.cats.push({ cat_id: fcats.f_cat_id });
          this.cats.push({ cat_id: data.f_cat_id });
          this.cats.push({ cat_id: data.cat_id });
          console.log(this.cats, "aa");
          this.mall_api.categoryDetail(data.cat_id).then((res) => {
            console.log(res, "rs");
            this.product_attr_list = res.Data.attr.product_attr_list;
            this.product_qua_list = res.Data.attr.product_qua_list;
            console.log(this.product_attr_list, " this.product_attr_list");
            this.pAttr = this.product_attr_list.filter(
              (x) => x.is_required == true
            );
            this.pAttr.forEach((x) => {
              if (x.type_v2 == "select_one" || x.type_v2 == "select_many") {
                x.sValue = x.value.split(";");
              }
            });
            console.log(this.pAttr, "pAttr");
          });
        }
      }
    },
    onCreateOpened() {
      this.getOption();
      this.api.getMaxOrderId().then((res) => {
        if (res.Code == 0) this.data.OrderId = res.Data;
      });
    },
    getOption() {
      // this.loading(true);  //打开加载效果
      // this.lable_api.list({ State: 1 }).then(res => {
      //   if (res.Code == 0) {
      //     this.labelList = res.Data;
      //   }
      // });

      //名称链转为数组
      var typeNames = this.data.TypeNameChain.split(".");
      //获取第一个
      var typeName = typeNames.length > 0 ? typeNames[0] : "";
      console.log("getOption", typeName, this.data.TypeNameChain);

      this.brand_api.list({ State: 1, TypeName: typeName }).then((res) => {
        if (res.Code == 0) {
          this.Brands = res.Data;
        }
      });
    },
    onEditOpened(data) {
      this.data.Attributes = data.Attributes.map((x, i) => {
        // x.AttributeValues.forEach(v => v.T = null);
        // return { ...x, DelAttributeValues: [], T: null }
        return { ...x, Index: i, T: null };
      });
      this.data.title = data.GoodsName;
      this.getOption();
      // data.Labeldetails.forEach(e => {    //这里的data是指传进来得参数，就是后端返回的数据集，data.Labeldetails就是标签子表，所以名称得和子表定义得一致
      //   this.place.push({ ...e });
      //   this.arr2.push(e.LabelId);
      // })
      // var arr = [];
      // for (let i = 0; i < this.arr2.length; i++) {
      //   const e = this.arr2[i];
      //   if (i == 0) arr.push(e);
      //   else {
      //     for (let j = 0; j < arr.length; j++) {
      //       const n = arr[j];
      //       if (n > e) {
      //         arr.splice(j, 0, e);
      //         break;
      //       }
      //       if (j == arr.length - 1) {
      //         arr.push(e);
      //         break;
      //       }
      //     }
      //   }
      // }
      // this.arr2 = arr;

      console.log("data", this.data);
    },
    onBeforeSave() {
      var data = JSON.parse(JSON.stringify(this.data));
      data = this.$commonJs.obj.removeNullKey(data);

      var to = [];
      var arr2 = this.arr2;
      var place = this.place;
      place.forEach((e) => {
        if (arr2.indexOf(e.LabelId) == -1) {
          to.push({ ...e, T: 2 });
        }
      });
      arr2.forEach((e) => {
        var obj = place.find((x) => x.LabelId == e);
        if (!obj) {
          to.push({
            T: 0,
            GoodsId: this.data.RecordId,
            RecordId: 0,
            LabelId: e,
          });
        }
      });
      data.Labeldetails = to; //这句话就是把标签选中的id传给参数中的Labeldetails，然后去调用后端接口传这个数据进去

      if (this.data.Attributes.length == 0) {
        this.$message.warning("请添加商品规格");
        return false;
      }

      if (this.data.Attributes.some((x) => !x.AttributeName)) {
        this.$message.warning("规格名称不能为空");
        return false;
      }

      // if (this.data.Attributes.some(x => !x.DistributionPrice)) {
      //   this.$message.warning("分销价不能为空");
      //   return false;
      // }

      // if (this.data.Attributes.some(x => !x.OriginalPrice)) {
      //   this.$message.warning("销售指导价不能为空");
      //   return false;
      // }

      // if (this.data.Attributes.some(x => !x.PlatformPrice)) {
      //   this.$message.warning("平台价不能为空");
      //   return false;
      // }

      ////属性值保存验证
      // var warningMsg = "";
      // this.data.Attributes.forEach(x => {
      //   if (x.AttributeValues.some(x => !x.AttributeValue)) {
      //     warningMsg += x.AttributeName + "的属性值不能为空<br />";
      //   }
      // })
      // if (warningMsg != "") {
      //   this.$message({
      //     dangerouslyUseHTMLString: true,
      //     message: `<div class="my-message">${warningMsg}</div>`,
      //     type: "warning"
      //   });
      //   return false;
      // }

      data.Attributes = this.data.Attributes.filter((x) => x.T != null);
      ////取得
      // data.Attributes.forEach(x => {
      //   x.AttributeValues = x.AttributeValues.filter(v => v.T != null);
      //   x.DelAttributeValues.forEach(dv => x.AttributeValues.push(dv));
      // })
      this.DelAttributes.forEach((x) => data.Attributes.push(x));

      console.log("save", data);

      // return false;
      this.loading();
      this.api.save(data).then((res) => {
        this.loading(false);
        if (res.Code == 0) {
          this.$message.success(res.Msg);
          this.close(true);
          this.$emit("close-saved");
        } else {
          this.$message.error(res.Msg);
        }
      });
      return false;
    },
    onClosed() {
      this.data.Attributes = [];
      this.DelAttributes = [];
      this.SelectAttributes = [];
      this.arr2 = [];
      this.data.Labeldetails = [];
      this.labelList = [];
      this.place = [];
    },
    selectAttribute(selection) {
      this.SelectAttributes = selection;
    },
    setEdit(data, attribute = null) {
      if (data.T != 0) data.T = 1;
      ////通过attribute是否为空来区分是修改属性还是修改属性中的值
      // if (attribute != null) {
      //   if (attribute.T != 0) attribute.T = 1;
      // }
    },
    //添加属性
    addAttribute() {
      // if (this.data.Attributes.length >= 3) {
      //   this.$message.warning("最多存在三条属性");
      //   return;
      // }
      var orders = this.data.Attributes.map((x) => x.OrderId).sort((a, b) => {
        return b - a;
      });
      this.data.Attributes.push({
        Index: this.data.Attributes.length,
        RecordId: 0,
        OrderId: orders.length == 0 ? 0 : orders[0] + 1,
        GoodsId: this.data.RecordId, //商品
        AttributeName: "", //属性名称
        // OriginalPrice: this.data.OriginalPrice, //商品原价
        // PlatformPrice: this.data.PlatformPrice, //平台价
        // DistributionPrice: this.data.DistributionPrice, //分销价
        T: 0,
        // AttributeValues: [],
        // DelAttributeValues: []
      });
    },
    //删除属性
    delAttribute() {
      if (this.SelectAttributes.length == 0) {
        this.$message.warning("请选择要删除的数据");
        return;
      }
      this.SelectAttributes.forEach((x) => {
        if (x.T != 0) {
          // x.AttributeValues.forEach(w => {
          //   if (w.T != 0) x.DelAttributeValues.push({ ...w, T: 2 })
          // })
          // x.AttributeValues = [];
          this.DelAttributes.push({ ...x, T: 2 });
        }
        this.data.Attributes.splice(x.Index, 1);
      });
      //清空选中的数据
      this.SelectAttributes = [];
      //对序号进行重新排序
      this.data.Attributes.forEach((x, i) => (x.Index = i));
    },
  },
};
</script>